var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHolidaybtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.125V6M9 4.125C9 3.08947 9.83947 2.25 10.875 2.25C11.9105 2.25 12.75 3.08947 12.75 4.125C12.75 5.16053 11.9105 6 10.875 6M9 4.125C9 3.08947 8.16053 2.25 7.125 2.25C6.08947 2.25 5.25 3.08947 5.25 4.125C5.25 5.16053 6.08947 6 7.125 6M9 6H10.875M9 6H7.125M9 6V10.5M10.875 6H13.3501C14.1902 6 14.6097 6 14.9305 6.16349C15.2128 6.3073 15.4429 6.5366 15.5867 6.81885C15.75 7.1394 15.75 7.55925 15.75 8.39768V10.5M7.125 6H4.65015C3.81007 6 3.38972 6 3.06885 6.16349C2.7866 6.3073 2.5573 6.5366 2.41349 6.81885C2.25 7.13972 2.25 7.56007 2.25 8.40015V10.5M2.25 10.5V12.6001C2.25 13.4402 2.25 13.86 2.41349 14.1809C2.5573 14.4632 2.7866 14.6929 3.06885 14.8367C3.3894 15 3.80925 15 4.64768 15H9M2.25 10.5H9M9 10.5V15M9 10.5H15.75M9 15H13.3523C14.1908 15 14.61 15 14.9305 14.8367C15.2128 14.6929 15.4429 14.4632 15.5867 14.1809C15.75 13.8604 15.75 13.4411 15.75 12.6027V10.5",
    stroke: "#2D53DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidaybtn);
export default __webpack_public_path__ + "static/media/holidaybtn.aaa6f6c74c2864b8857b98d33b8366ea.svg";
export { ForwardRef as ReactComponent };